import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'

const JobRedirect = () => {
    const location = useLocation()

    return (
        <Navigate
            replace
            to='list'
            state={location.state}
        />
    )
}

export default JobRedirect